import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { FadeUpGroup } from "../components/FadeUpGroup";
import { PRODUCTS } from "../lib/products";

export const ProductsPage = () => {
    return (
        <>
            <section className="section" data-testid="products-page">
                <div className="container">
                    <div className="section-head">
                        <span className="eyebrow">Products</span>
                        <h1 className="h1" style={{ marginTop: 18 }}>Standalone products. Pick what you need.</h1>
                        <p>Each Scitus.ai product is engineered to win on its own. Take one. Take three. They share identity and data the moment you take two — and you save 25% when you bundle.</p>
                    </div>

                    <FadeUpGroup>
                        <div className="products-overview-grid">
                            {PRODUCTS.map((p) => {
                                const Icon = p.icon;
                                const hasLockup = p.logo && p.logo.src && p.logo.fit === "lockup";
                                const hasMark = p.logo && p.logo.src && p.logo.fit === "mark";
                                const needsLightTile = p.logo?.needsLightTile === true;
                                return (
                                    <a key={p.slug} href={`/products/${p.slug}`} className="overview-card fade-up" data-testid={`overview-${p.slug}`}>
                                        <div className="overview-head">
                                            <span className={`overview-logo overview-logo--${p.logo?.fit || "icon"}${needsLightTile ? " overview-logo--lit" : ""}`}>
                                                {hasLockup || hasMark ? (
                                                    <img
                                                        src={p.logo.src}
                                                        alt={`${p.name} logo`}
                                                        loading="lazy"
                                                        decoding="async"
                                                    />
                                                ) : (
                                                    <Icon size={28} />
                                                )}
                                            </span>
                                            <div>
                                                <div className="sub">{p.sub}</div>
                                                <h2 className="h3" style={{ fontSize: "1.6rem", marginTop: 4 }}>{p.name}</h2>
                                            </div>
                                        </div>
                                        <p className="muted" style={{ marginTop: 16 }}>{p.tagline}</p>
                                        <ul className="feature-list" style={{ marginTop: 18 }}>
                                            {p.pillars.map((pi) => (
                                                <li key={pi.h}>
                                                    <span className="check"><Check size={14} /></span>
                                                    <span><strong style={{ color: "var(--text)" }}>{pi.h}.</strong> <span className="muted">{pi.p}</span></span>
                                                </li>
                                            ))}
                                        </ul>
                                        <div className="industry-chips" style={{ marginTop: 18 }}>
                                            {p.industries.slice(0, 4).map((ind) => <span key={ind} className="chip">{ind}</span>)}
                                        </div>
                                        <span className="link-arrow" style={{ marginTop: 22, display: "inline-flex" }}>
                                            Explore {p.name} <ArrowRight size={16} />
                                        </span>
                                    </a>
                                );
                            })}
                        </div>
                    </FadeUpGroup>
                </div>
            </section>

            <section className="section" style={{ paddingTop: 0 }}>
                <div className="container">
                    <div className="cta-banner">
                        <div>
                            <h2 className="h2">Not sure where to start?</h2>
                            <p className="lead mt-4">Book a 30-minute call and we'll recommend the right two products for your business.</p>
                        </div>
                        <a href="/contact" className="btn btn-primary btn-lg" data-testid="products-overview-cta">
                            Talk to us <ArrowRight size={18} />
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ProductsPage;
